module.exports = __webpack_public_path__ + "static/media/avatar.6a7fc5ea.svg";